import {Component, OnInit} from '@angular/core';
import {LanguageService} from "../service/language.service";
import {Lang} from "../model/lang.model";
import {CookieService} from "ngx-cookie-service";
import {keys} from "../shared/constants";
import {Locale} from 'sdv-common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  private now: Date;

  constructor(private languageService: LanguageService,
              private cookieService: CookieService) {
  }

  ngOnInit() {
    let _this = this;
    let exec = () => {
      _this.now = new Date();
      let nextYear = new Date(_this.now.getFullYear() + 1, 0, 1, 0, 0, 0, 0);
      let timeout = nextYear.getTime() - _this.now.getTime();
      setTimeout(exec, timeout);
    }
    exec();
  }

  switchLang(language: Lang) {
    let settings = JSON.parse(this.cookieService.get(keys.settings) || '{}');
    if (language.id === Locale.RUSSIAN.id) {
      settings.lang = Locale.RUSSIAN.name;
    } else if (language.id === Locale.UKRAINE.id) {
      settings.lang = Locale.UKRAINE.name;
    } else {
      settings.lang = Locale.ENGLISH.name;
    }
    this.cookieService.set(keys.settings, JSON.stringify(settings));
  }
}
